export const OVERLAY_LAYER_ID = "PIN-MODE-OVERLAY";
export const PIN_MODE_LAYER_ID = "PIN-MODE-LAYER";

export const LOCATOR_URL =
  "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer";

export const DEFAULT_ZOOM_LEVEL_DESKTOP = 7;
export const DEFAULT_ZOOM_LEVEL_MOBILE = 6;
export const DEFAULT_CENTER_POINT = [-84.611389, 43.408611];
export const JACKSON_MI_CENTER = [-84.4013, 42.2459];
export const MIN_SCALE = 36111.909643;
export const OUT_FIELDS = ["*"];

export enum ELocationServicesErrorMessages {
  PERMISSION_DENIED = "Location services disabled. To help find nearby streetlights, go to your browser settings, enable your location, and ​​​​​​​refresh this page.",
  POSITION_UNAVAILABLE = "There was an error retrieving your location; please refresh the page to try again.",
  TIMEOUT = "Geolocation request timed out; please try again.",
  UNKNOWN = "An unknown error occured; please try again.",
}

export enum EMarkerStatuses {
  REPORTED = "Reported",
  IN_PROGRESS = "In Progress",
  EXTENDED_REPAIR = "Extended Repair",
  COMPLETED = "Completed",
  NON_CE = "Non-CE Streetlight",
  DOES_NOT_EXIST = "Streetlight DNE",
}
